import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { CustomerActionTypes, CustomerActions } from "../../../actionTypes/master/customerActionTypes";
import {
  createCustomerApi,
  editCustomerDataByIdApi,
  getCustomerDataByIdApi,
  getCustomerListApi,
} from "../../requests/master/customerRequests";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { getCustomerList, setCustomerDataById, setCustomerList, setCustomerListPageCount } from "../../../actions/master/customerActions";


function* createCustomerHandler(action: CustomerActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createCustomerApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerListHandler(action: CustomerActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getCustomerListApi, action.payload);

    if (data.status) {
      yield put(setCustomerList(data?.data?.rows));
      yield put(setCustomerListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerDataByIdHandler(action: CustomerActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getCustomerDataByIdApi, action.payload);
    if (data.status) {
      yield put(setCustomerDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editCustomerDataByIdHandler(action: CustomerActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editCustomerDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getCustomerList({ page: 0, pageLimit: 75 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// customer sagas
export default function* customerSaga() {
  yield takeLatest(CustomerActions.CREATE_CUSTOMER, createCustomerHandler);
  yield takeLatest(CustomerActions.GET_CUSTOMER_LIST, getCustomerListHandler);
  yield takeLatest(CustomerActions.GET_CUSTOMER_DATA_BY_ID, getCustomerDataByIdHandler);
  yield takeLatest(CustomerActions.EDIT_CUSTOMER_DETAILS, editCustomerDataByIdHandler);
}
